/**
 * @file View
 * @author Yu Zong(liuxuanzy@qq.com)
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import { useRefCallback } from '@tencent/glue-react-use';
import { useStyleTransform } from '../hooks/useStyleTransform';
import { IMAGE_PLACEHOLDER } from '../const';
export var Image = function (props) {
    var id = props.id, _a = props.className, elemClassName = _a === void 0 ? '' : _a, _b = props.style, elemStyle = _b === void 0 ? {} : _b, _c = props.mode, mode = _c === void 0 ? 'stretch' : _c, _d = props.fixMode, fixMode = _d === void 0 ? 'width' : _d, fixOverflow = props.fixOverflow, src = props.src, _e = props.placeholder, placeholder = _e === void 0 ? IMAGE_PLACEHOLDER : _e, onError = props.onError, onLoad = props.onLoad, onClick = props.onClick, children = props.children;
    var _f = useStyleTransform(elemStyle, 'xj-h5-image', elemClassName), style = _f.style, config = __rest(_f, ["style"]);
    var _g = useState(placeholder), imageSrc = _g[0], setImageSrc = _g[1];
    var onLoadCallback = useRefCallback(onLoad);
    var onErrorCallback = useRefCallback(onError);
    useEffect(function () {
        if (!src) {
            return;
        }
        var image = new window.Image();
        image.onerror = function () {
            setImageSrc(placeholder);
            onErrorCallback();
        };
        image.onload = function () {
            setImageSrc(src);
            onLoadCallback();
        };
        image.src = src;
    }, [src]);
    var autoWidth = mode === 'fix-ratio' && fixMode !== 'width';
    var autoHeight = mode === 'fix-ratio' && fixMode !== 'height';
    return (React.createElement("div", __assign({}, config, { id: id, onClick: onClick, style: __assign(__assign({}, style), { overflow: mode === 'fix-ratio' && fixOverflow ? 'visible' : 'hidden' }) }),
        React.createElement("img", { style: {
                width: autoWidth ? 'auto' : '100%',
                height: autoHeight ? 'auto' : '100%',
                objectFit: mode === 'contain' || mode === 'cover' ? mode : 'unset',
            }, src: imageSrc, alt: "img" }),
        children));
};
